// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Burundi from '../_raw/flag/icon_flag_burundi.png';

export default () => <img src={Burundi} alt="Burundi" />;
